import { NodeAgent } from "@/components/nodes/agent"
import { NodeComposite } from "@/components/nodes/composite"
import { NodeJavascript } from "@/components/nodes/javascript"
import { NodeKnowledgeSet } from "@/components/nodes/knowledgeset"
import { NodeQuickStart } from "@/components/nodes/quickstart"
import { NodeSmartNotes } from "@/components/nodes/smartnotes"
import GroupNode from "@/components/blueprints/GroupNode"
import NodeAIKnot from "@/components/nodes/ai-knot/NodeAIKnot"
import NodeAgency from "@/components/nodes/agency/NodeAgency"
import NodeDiagrams from "@/components/nodes/diagrams/NodeDiagrams"
import NodeDiagramsMermaid from '@/components/nodes/diagrams-mermaid/NodeDiagramsMermaid'
import NodeDocument from "@/components/nodes/document/NodeDocument"
import NodeDocumentDesigner from "@/components/nodes/document-designer/NodeDocumentDesigner"
import NodeDomainKnowledge from "@/components/nodes/domain-knowledge/NodeDomainKnowledge"
import NodeFileMiner from "@/components/nodes/file-miner/NodeFileMiner"
import NodeGlobalConstants from "@/components/nodes/global-constants/NodeGlobalConstants"
import NodeGroupBlueprint from "@/components/nodes/group-blueprint/NodeGroupBlueprint"
import NodeHTMLFields from "@/components/nodes/html-fields/NodeHTMLFields"
import NodeImageGenerator from "@/components/nodes/image-generator/NodeImageGenerator"
import NodeIntellica from "@/components/nodes/intellica/NodeIntellica"
import NodePresence from "@/components/nodes/presence/NodePresence"
import NodeResource from "@/components/nodes/resource/NodeResource"
import NodeResourcePDF from "@/components/nodes/resource-pdf/NodeResourcePDF"
import NodeStrategy from "@/components/nodes/strategy/NodeStrategy"
import NodeWebExtract from "@/components/nodes/web-extract/NodeWebExtract"
import NodeWebSearch from "@/components/nodes/web-search/NodeWebSearch"
import NodeFacilitator from "@/components/nodes/facilitator/NodeFacilitator"
import NodeResearcher from "@/components/nodes/researcher/NodeResearcher"
import NodeWorkflow from "@/components/nodes/workflow/NodeWorkflow"
import NodeQuickStartDynamic from "@/components/nodes/quick-start-dynamic/NodeQuickStartDynamic"
import { AnnotationNode } from "@/components/nodes/annotation-node/annotation-node"
import { GhostNode } from "@/hooks/useIncompleteEdge"
// Blueprint node imports
// Group node for visual node grouping

export const nodeTypes = () => ({
  annotationnode: (props) => <AnnotationNode {...props} />,
  ghost: GhostNode,
  nodequickstart: (props) => <NodeQuickStart {...props} />,
  nodedocument: (props) => <NodeDocument {...props} />,
  nodeintellica: (props) => <NodeIntellica {...props} />,
  nodedocumentdesigner: (props) => <NodeDocumentDesigner {...props} />,
  nodesmartnotes: (props) => <NodeSmartNotes {...props} />,
  nodediagrams: (props) => <NodeDiagrams {...props} />,
  nodediagramsmermaid: (props) => <NodeDiagramsMermaid {...props} />,
  nodefileminer: (props) => <NodeFileMiner {...props} />,
  nodejavascript: (props) => <NodeJavascript {...props} />,
  nodeimagegenerator: (props) => <NodeImageGenerator {...props} />,
  noderesource: (props) => <NodeResource {...props} />,
  noderesourcepdf: (props) => <NodeResourcePDF {...props} />,
  nodestrategy: (props) => <NodeStrategy {...props} />,
  nodepresence: (props) => <NodePresence {...props} />,
  nodeagency: (props) => <NodeAgency {...props} />,
  nodeknowledgeset: (props) => <NodeKnowledgeSet {...props} />,
  nodecomposite: (props) => <NodeComposite {...props} />,  nodequickstartdynamic: (props) => <NodeQuickStartDynamic {...props} />,  
  nodewebextract: (props) => <NodeWebExtract {...props} />,  nodewebsearch: (props) => <NodeWebSearch {...props} />,
  nodefacilitator: (props) => <NodeFacilitator {...props} />,
  noderesearcher: (props) => <NodeResearcher {...props} />,
  nodeglobalconstants: (props) => <NodeGlobalConstants {...props} />,
  nodeagent: (props) => <NodeAgent {...props} />,
  nodedomainknowledge: (props) => <NodeDomainKnowledge {...props} />,
  nodeaiknot: (props) => <NodeAIKnot {...props} />,
  // Blueprint node mappings
  nodehtmlfields: (props) => <NodeHTMLFields {...props} />,
  nodegroupblueprint: (props) => <NodeGroupBlueprint {...props} />,
  nodeworkflow: (props) => <NodeWorkflow {...props} />,
  // Group node for visual node grouping
  groupnode: (props) => <GroupNode {...props} />,
  // Built-in ReactFlow group node for containers
  group: undefined, // ReactFlow's built-in group node
})
